import React from "react";
import { Link } from "react-router-dom";
import { zaloIcon, fbIco, messenger } from "../../assets";
import { SITE } from "../../config/sites";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        {/* Brand Info */}
        <div className="footer-col-brand">
          <div className="footer-logo-text">{SITE.siteName}</div>
          {/* Câu giới thiệu khác nhau giữa 2 site: .com lấy Liên Quân làm
              trọng tâm, .vn lấy Đột Kích (CF). Để trong sites.json chứ đừng
              viết cứng ở đây — trước đây viết cứng nên .com cũng nói
              "thuê acc Đột Kích", ngược với hướng SEO của nó. */}
          <p>{SITE.footerTagline}</p>
          <div className="footer-working-hours">
            <span className="hours-emoji" aria-hidden="true">⏰</span>
            <span>Giờ mở cửa: 7h30 - 23h15 hàng ngày</span>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="footer-col-nav">
          <div className="footer-col-title">Điều Hướng</div>
          <ul>
            <li>
              <Link to="/">Trang Chủ</Link>
            </li>
            {SITE.footerLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Connect Social */}
        <div className="footer-col-social">
          <div className="footer-col-title">Kết Nối Với Admin</div>
          <div className="footer-social-links">
            <a
              href="https://zalo.me/0777650650"
              className="footer-social-link zalo"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.gtag_report_conversion_zalo?.()}
            >
              <span className="sl-icon">
                <img src={zaloIcon} alt="Zalo" width="20" height="20" loading="lazy" />
              </span>
              <div className="sl-info">
                <span className="sl-name">Zalo Chat</span>
                <span className="sl-handle">0777.650.650</span>
              </div>
            </a>
            <a
              href="https://www.facebook.com/ThueAcCF"
              className="footer-social-link fb"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="sl-icon">
                <img src={fbIco} alt="Facebook" width="20" height="20" loading="lazy" />
              </span>
              <div className="sl-info">
                <span className="sl-name">Facebook Admin</span>
                <span className="sl-handle">Nguyễn Hoàng Lê</span>
              </div>
            </a>
            <a
              href="https://www.tiktok.com/@thueacccfzomc4"
              className="footer-social-link tiktok"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="sl-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.17-2.86-.6-4.12-1.43-.22-.15-.45-.32-.64-.51v6.92c0 2.12-.72 4.24-2.22 5.74-1.5 1.5-3.61 2.22-5.74 2.22-2.12 0-4.24-.72-5.74-2.22-1.5-1.5-2.22-3.61-2.22-5.74 0-2.13.72-4.24 2.22-5.74 1.5-1.5 3.61-2.22 5.74-2.22.41 0 .82.03 1.22.08v4.02c-.4-.08-.82-.1-1.22-.08-1.07.03-2.13.43-2.89 1.19-.76.76-1.16 1.82-1.19 2.89-.03 1.07.37 2.13 1.13 2.89.76.76 1.82 1.16 2.89 1.19 1.07.03 2.13-.37 2.89-1.13.76-.76 1.16-1.82 1.19-2.89V0z" />
                </svg>
              </span>
              <div className="sl-info">
                <span className="sl-name">TikTok Review</span>
                <span className="sl-handle">@thueacccfzomc4</span>
              </div>
            </a>
            <a
              href="https://www.facebook.com/messages/t/100009374322909"
              className="footer-social-link messenger"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => window.gtag_report_conversion_messenger?.()}
            >
              <span className="sl-icon">
                <img src={messenger} alt="Messenger" width="20" height="20" loading="lazy" />
              </span>
              <div className="sl-info">
                <span className="sl-name">Messenger</span>
                <span className="sl-handle">Trò chuyện ngay</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <span>{`© 2026 ${SITE.siteName} — ${SITE.brandLine}.`}</span>
          <div className="footer-tags">
            {SITE.footerLegalLinks.map((link) => (
              <a key={link.href} href={link.href}>
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
